import { NgModule } from '@angular/core';

import { provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        textFormSplitColumnFeature: {
          cmsComponents: ['TextFormSplitColumnComponent'],
          module: () => import('./text-form-split-column.module').then((m) => m.DpTextFormSplitColumnModule)
        }
      }
    })
  ]
})
export class DpTextFormSplitColumnFeatureModule {}
